import {
    ConsolidatedLocationView,
    EventVehicleDto,
    CadNextRelatedDataVehicleQuery,
    CadNextRelatedDataLocationQuery,
    RelatedDataPersonQuery,
    EventPersonDto,
} from '@mark43/cad-api';
import { observer } from 'mobx-react';
import { useRelatedData } from '../../../related-data/use-related-data';
import { RelatedDataTabContent } from './related-data-tab-content';

export const RelatedDataTabContentNewEvent = observer(
    function RelatedDataTabContentNewEvent(props: {
        phoneNumbers: string[];
        vehicles: EventVehicleDto[];
        location?: ConsolidatedLocationView;
        reportingParties: EventPersonDto[];
        vehicleQueries: CadNextRelatedDataVehicleQuery[];
        relatedDataLocationQuery?: CadNextRelatedDataLocationQuery;
        personQueries: RelatedDataPersonQuery[];
    }) {
        const { viewMoreCadEvents, viewMoreRmsReports, viewMoreVehicles } = useRelatedData();
        const {
            phoneNumbers,
            vehicleQueries,
            relatedDataLocationQuery,
            personQueries,
            ...rest
        } = props;

        return (
            <RelatedDataTabContent
                {...rest}
                phoneNumbers={phoneNumbers}
                onViewMoreCadEvents={() => {
                    viewMoreCadEvents({
                        isNewEvent: true,
                        newEventFields: {
                            phoneNumbers,
                            vehicleQueries,
                            relatedDataLocationQuery,
                            personQueries,
                        },
                    });
                }}
                onViewMoreRmsReports={() => {
                    viewMoreRmsReports({
                        isNewEvent: true,
                        newEventFields: {
                            phoneNumbers,
                            vehicleQueries,
                            relatedDataLocationQuery,
                            personQueries,
                        },
                    });
                }}
                onViewMoreVehicles={() => {
                    viewMoreVehicles({
                        isNewEvent: true,
                        newEventFields: {
                            phoneNumbers,
                            vehicleQueries,
                            relatedDataLocationQuery,
                            personQueries,
                        },
                    });
                }}
            />
        );
    }
);
